module.exports = __webpack_public_path__ + "assets/img/familyCrest-240fa1bc.png";